import React from 'react';
import Akko from '../azienda/akko.webp';
import KbdFans from '../azienda/kbdfans.webp';
import Wuque from '../azienda/wuque.webp';
import KindleStar from '../azienda/kindlestar.webp';
import Nuphy from '../azienda/nuphy.webp';
import Mode from '../azienda/mode.webp';
import Khor from '../azienda/khor.webp';

const MyClients: React.FC = () => {

    return <section id='myclients' className='section'>
        <h2 className='title2 center'>Companies that have collaborated with me</h2>
        <div className="container-scrolling">
            <div className="photobanner">
                <img alt='Mode' className='logoAzienda' src={Mode}></img>
                <img alt='Akko' className='logoAzienda' src={Akko}></img>
                <img alt='Wuque Studio' className='logoAzienda' src={Wuque}></img>
                <img alt='Khor' className='logoAzienda' src={Khor}></img>
                <img alt='KbdFans' className='logoAzienda' src={KbdFans}></img>
                <img alt='KindleStar' className='logoAzienda' src={KindleStar}></img>
                <img alt='Nuphy' className='logoAzienda' src={Nuphy}></img>
                <img alt='Mode' className='logoAzienda' src={Mode}></img>
                <img alt='Akko' className='logoAzienda' src={Akko}></img>
                <img alt='Wuque Studio' className='logoAzienda' src={Wuque}></img>
                <img alt='Khor' className='logoAzienda' src={Khor}></img>
                <img alt='KbdFans' className='logoAzienda' src={KbdFans}></img>
                <img alt='KindleStar' className='logoAzienda' src={KindleStar}></img>
                <img alt='Nuphy' className='logoAzienda' src={Nuphy}></img>
            </div>
        </div>
    </section>
}

export default MyClients